module.exports = __webpack_public_path__ + "img/ContratoHNNacional1.dcc70ca3.png";